/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-underscore-dangle */
import moment from 'moment';
import Delta, { Op } from 'quill-delta';
import { IWindowService } from 'angular';
import { SalesAPIService } from 'shared/api/sales-api.service';
import { PlatformsAPIService } from '../../../shared/api/platforms-api.service';
import { SettingsAPIService } from '../../../shared/api/settings-api.service';
import { NumberConversionService } from '../../../shared/converter/number-converter.service';
import { FileService } from '../../../shared/storage/file.service';
import { DeepPartial } from '../../../src/app/@shared-types';
import { EExternalAPI } from '../../../src/app/@shared-types/api';
import {
  FrontendSellerAPIAdRequest,
  MobileSellerAPIAccount,
  MobileSellerAPIConfig,
  MobileSellerDescriptionText,
} from '../../../src/app/@shared-types/api/mobile-de';
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';
import LogService from '../../../src/app/shared/services/log';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';
import { getAdditionalOptionsAsOps, getModelDataAsOps, getSeriesOptionsAsOps } from '../../../src/app/shared/models/vehicle/description';

export class OnlinePlatformsFormController {
  private exit!: (data: VehicleFormComponentExitFunction) => void;

  private fileService: FileService;

  private logService: LogService;

  private toastService: ToastService;

  private vehicle!: AutoboardVehicle;

  private mobileSellerConfig: MobileSellerAPIConfig | null = null;

  public mobileSellerAccounts: { [key: string]: string } = {};

  private $window: IWindowService;

  public formData: {
    deliveryDate: string | null,
    deliveryPeriod: string,
    warranty: boolean,
    dealersOnly: boolean,
    mobileSellerId?: string,
    onlinePrice?: string,
    mobileSellerDescription?: MobileSellerDescriptionText,
    sending: boolean,
    highlights: string[],
    title: string,
    showDescription: boolean,
    internalNumber: string,
    deactivated: boolean,
  } = {
    deliveryDate: null,
    warranty: false,
    dealersOnly: false,
    deliveryPeriod: '',
    sending: false,
    title: '',
    highlights: [],
    showDescription: true,
    internalNumber: '',
    deactivated: false,
  };

  public errors = '';

  private settingsApiService: SettingsAPIService;

  private platformsApiService: PlatformsAPIService;

  private numberConversionService: NumberConversionService;

  private salesApiService: SalesAPIService;

  /* @ngInject */
  constructor(
    $window: IWindowService,
    fileService: FileService,
    logService: LogService,
    toastService: ToastService,
    settingsApiService: SettingsAPIService,
    platformsApiService: PlatformsAPIService,
    numberConversionService: NumberConversionService,
    salesApiService: SalesAPIService,
  ) {
    this.fileService = fileService;
    this.logService = logService;
    this.toastService = toastService;
    this.settingsApiService = settingsApiService;
    this.platformsApiService = platformsApiService;
    this.numberConversionService = numberConversionService;
    this.salesApiService = salesApiService;
    this.$window = $window;

    this.getMobileSellerConfig();
  }

  public $onInit = (): void => {
    if (this.vehicle.apiData?.MOBILE_SELLER) {
      const { adMeta } = this.vehicle.apiData.MOBILE_SELLER;

      this.formData.onlinePrice = this.numberConversionService
        .convertFloatToFrontend(this.vehicle.vehicleData.price.onlinePrice || 0);

      this.formData.mobileSellerDescription = adMeta.description;
      this.formData.title = adMeta.title || '';
      if (adMeta.deliveryDate) this.formData.deliveryDate = adMeta.deliveryDate as any as string;
      if (adMeta.deliveryPeriod) this.formData.deliveryPeriod = String(adMeta.deliveryPeriod);
      if (adMeta.warranty) this.formData.warranty = true;
      if (adMeta.dealersOnly) this.formData.dealersOnly = true;
      if (adMeta.highlights) this.formData.highlights = adMeta.highlights;
      if (adMeta.internalNumber) this.formData.internalNumber = adMeta.internalNumber;
      if (adMeta.deactivated) this.formData.deactivated = adMeta.deactivated;
    } else {
      this.formData.mobileSellerDescription = {
        formatted: '',
        raw: {},
      };
      this.formData.title = this.vehicle.modelData?.modelDescription || '';
      this.formData.onlinePrice = this.numberConversionService
        .convertFloatToFrontend(this.vehicle.vehicleData.price.onlinePrice || 0);
      if (this.vehicle.vehicleData.condition.endWarranty) {
        if (moment(this.vehicle.vehicleData.condition.endWarranty).isAfter(moment())) {
          this.formData.warranty = true;
        }
      }
    }
  };

  private parseDeliveryPeriod = (): number | undefined => {
    if (!this.formData.deliveryPeriod) return undefined;
    return parseInt(this.formData.deliveryPeriod, 10);
  };

  private getMobileSellerConfig = async (): Promise<void> => {
    const configs = await this.settingsApiService
      .getAPIConfig<MobileSellerAPIConfig[]>(EExternalAPI.MOBILE_SELLER).catch();

    this.setMobileSellerAccounts(configs[0].accounts);
    [this.mobileSellerConfig] = configs;
  };

  private setMobileSellerAccounts = (accounts: MobileSellerAPIAccount[]): void => {
    accounts.forEach((a) => {
      this.mobileSellerAccounts[a.sellerId] = a.name;
    });
  };

  public publishMobileAd = async (
    updateVehicle: boolean,
  ): Promise<void> => {
    this.errors = '';
    if (this.formData.onlinePrice === '0') {
      this.errors = 'Bitte gib einen gültigen Verkaufspreis ein.';
      return;
    }
    if (!this.formData.onlinePrice || !this.formData.mobileSellerId) return;
    this.formData.sending = true;

    const request: FrontendSellerAPIAdRequest = {
      vehicleId: String(this.vehicle._id),
      sellerId: this.formData.mobileSellerId,
      onlinePrice: this.numberConversionService.convertFloatToBackend(this.formData.onlinePrice),
      adData: {
        description: this.formData.mobileSellerDescription,
        highlights: this.formData.highlights,
        title: this.formData.title,
        warranty: this.formData.warranty,
        dealersOnly: this.formData.dealersOnly,
        internalNumber: this.formData.internalNumber,
        deactivated: this.formData.deactivated,
      },
    };

    if (this.formData.deliveryDate) {
      // eslint-disable-next-line max-len
      request.adData.deliveryDate = this.numberConversionService.frontendStringToDate(this.formData.deliveryDate);
    } else if (this.formData.deliveryPeriod) {
      request.adData.deliveryPeriod = this.parseDeliveryPeriod();
    }

    /** Only update vehicle if specified */
    if (updateVehicle) {
      const updateData: DeepPartial<AutoboardVehicle> = {
        _id: this.vehicle._id,
        vehicleData: {
          price: {
            onlinePrice: this.numberConversionService.convertFloatToBackend(
              this.formData.onlinePrice,
            ),
          },
        },
      };

      await this.salesApiService.putVehicle(updateData);
    }

    this.platformsApiService.postAd(request)
      .then((res) => {
        if (res.error) {
          this.formData.sending = false;
          this.errors = res.errorCodes.join('<br>');

          this.toastService.toast(ToastType.ERROR, 'Fehler beim Veröffentlichen der Anzeige auf mobile.de');
          return;
        }

        this.exit({ removeLock: false });
      })
      .catch((e) => {
        this.logService.error(e);
        this.toastService.toast(ToastType.ERROR, 'Fehler beim Veröffentlichen der Anzeige auf mobile.de');
        this.formData.sending = false;
        this.exit({ removeLock: true });
      });
  };

  public deleteMobileAd = async (exit: boolean): Promise<void> => {
    this.formData.sending = true;
    await this.platformsApiService.deleteAd(String(this.vehicle._id))
      .catch(() => {
        this.toastService.toast(ToastType.ERROR, 'Fehler beim Löschen der Anzeige.');
        this.formData.sending = false;
      });

    if (exit) this.exit({ removeLock: false });
  };

  private addOpsToDescription = (ops: Op[]): void => {
    if (!this.formData.mobileSellerDescription?.raw) return;

    if (!(this.formData.mobileSellerDescription.raw as unknown as Delta).ops) {
      (this.formData.mobileSellerDescription.raw as unknown as Delta).ops = [];
    }
    (this.formData.mobileSellerDescription.raw as unknown as Delta).ops.push(...ops);

    this.formData.showDescription = false;
    setTimeout(() => {
      this.formData.showDescription = true;
    }, 0);
  };

  /** This method adds the `Vehicle`'s `modelData` as text to
   * the end of the description input. */
  public addModelDescription = (): void => this.addOpsToDescription(
    getModelDataAsOps(this.vehicle),
  );

  public addSeriesOptions = (): void => this.addOpsToDescription(
    getSeriesOptionsAsOps(this.vehicle),
  );

  public addAdditionalOptions = (): void => this.addOpsToDescription(
    getAdditionalOptionsAsOps(this.vehicle),
  );

  public updateMobileAd = (): void => {
    if (!this.formData.onlinePrice) return;
    this.formData.sending = true;

    const vehicleUpdate: DeepPartial<AutoboardVehicle> = {
      _id: this.vehicle._id,
      vehicleData: {
        price: {
          onlinePrice: this.numberConversionService.convertFloatToBackend(
            this.formData.onlinePrice,
          ),
        },
      },
      apiData: {
        MOBILE_SELLER: {
          adMeta: {
            // eslint-disable-next-line max-len
            description: this.formData.mobileSellerDescription as DeepPartial<MobileSellerDescriptionText>,
            title: this.formData.title,
            highlights: this.formData.highlights,
            warranty: this.formData.warranty,
            dealersOnly: this.formData.dealersOnly,
            internalNumber: this.formData.internalNumber,
            deactivated: this.formData.deactivated,
          },
        },
      },
    };

    const adMeta = vehicleUpdate.apiData!.MOBILE_SELLER!.adMeta!;

    if (this.formData.deliveryDate) {
      // eslint-disable-next-line max-len
      adMeta.deliveryDate = this.numberConversionService.frontendStringToDate(this.formData.deliveryDate);
      adMeta.deliveryPeriod = null;
    } else if (this.formData.deliveryPeriod) {
      adMeta.deliveryPeriod = parseInt(this.formData.deliveryPeriod, 10);
      adMeta.deliveryDate = null;
    }

    this.salesApiService.putVehicle(vehicleUpdate)
      .then(() => this.exit({ removeLock: false }))
      .catch(() => {
        this.toastService.toast(ToastType.ERROR, 'Fehler beim Aktualisieren der Anzeige der Anzeige.');
        this.formData.sending = false;
      });
  };

  public addHighlight = (): number => this.formData.highlights.push('');

  public removeHightlight = (index: number): void => {
    this.formData.highlights = this.formData.highlights.splice(index);
  };

  public switchAccount = async (): Promise<void> => {
    if (this.formData.mobileSellerId === this.vehicle.apiData?.MOBILE_SELLER?.details.sellerId) {
      this.toastService.toast(ToastType.WARNING, 'Das Fahrzeug ist aktuell bei diesem Account veröffentlicht.');
      return;
    }

    await this.deleteMobileAd(false);
    await this.publishMobileAd(false);

    this.toastService.toast(ToastType.SUCCESS, 'Mobile.de Inserat wurde auf dem neuen Account veröffentlicht.');
  };
}
